<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLeave_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.43 0H4.57A2.573 2.573 0 0 0 2 2.57V7h5.587L6.449 4.708a.65.65 0 0 1 1.041-.749l3.581 3.581a.65.65 0 0 1 0 .92L7.49 12.041a.65.65 0 0 1-1.042-.749L7.587 9H2v4.43A2.573 2.573 0 0 0 4.57 16h6.859a2.573 2.573 0 0 0 2.57-2.57V2.57A2.57 2.57 0 0 0 11.43 0"
    />
</svg>
